export default __webpack_public_path__ + "static/media/image-study-board-2-w@2x.085f88a3.png";